import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomAppIcon({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="#373A3C" fillRule="nonzero">
        <path d="M16.85 6.51l-.126-.237A6.941 6.941 0 0015.596 4.8l-5.118 5.06-1.153-1.18-1.475 1.458 2.605 2.662 6.395-6.29z" />
        <path d="M15.498 9.107c.045.27.067.561.067.853 0 2.199-1.282 4.219-3.284 5.139a5.542 5.542 0 01-5.76-.853A5.764 5.764 0 015.33 7.2a5.501 5.501 0 016.253-2.603c.653.18 1.26.493 1.8.92l1.372-1.37c-.54-.425-1.125-.807-1.777-1.076-2.992-1.28-6.546-.337-8.616 2.11-1.934 2.333-2.317 5.587-.945 8.28a7.631 7.631 0 008.054 3.926c4.049-.74 6.749-4.622 6.006-8.661a5.903 5.903 0 00-.337-1.235l-1.642 1.616z" />
      </g>
    </svg>
  );
}
export default SvgIconCustomAppIcon;
